import { useContext } from "react";
import USQSUndoContext from "../contexts/USQSUndoProvider";

const useUSQSUndo = () => {
  return useContext(USQSUndoContext);
};

export default useUSQSUndo;
